import React from 'react';
import createSvgIcon from '@one-thd/sui-atomic-components/dist/utils/createSvgIcon';
import { Typography } from '@one-thd/sui-atomic-components';
import Responsive from 'react-responsive';

const ProxExtraPerksSVG = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.19995 14.4133H10.6981L11.9661 12.7838L13.1767 14.4133H16.7323L13.9676 10.6613H9.96461L7.19995 14.4133Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.19995 7.00004H10.6981L11.9661 8.62949L13.1767 7.00004H16.7323L13.9676 10.7521H9.96461L7.19995 7.00004Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.41871 17.0908L1.19995 22.9808L5.49332 22.4798L8.32629 24.9998L9.54667
        21.4777C6.98666 20.8457 4.8075 19.2469 3.41871 17.0908Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5278 17.0908L22.7466 22.9808L18.4532 22.4798L15.6202 24.9998L14.3999
        21.4777C16.9599 20.8457 19.139 19.2469 20.5278 17.0908Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18.6802C7.47853 18.6802 3.7998 15.0014 3.7998 10.48C3.7998 5.95854 7.47853 2.27982
        12 2.27982C16.5214 2.27982 20.2001 5.95854 20.2001 10.48C20.2001 15.0014 16.5214 18.6802
        12 18.6802ZM3 10.48C3 15.4417 7.03701 19.48
        12 19.48C16.963 19.48 21 15.4417 21 10.48C21 5.51699 16.963 1.47998
        12 1.47998C7.03701 1.47998 3 5.51699 3 10.48Z"
      fill="white"
    />
    <path
      d="M12 18.1502C7.77119 18.1502 4.32972 14.7088 4.32972 10.48H3.26988C3.26988 15.2941
        7.18586 19.2101 12 19.2101V18.1502ZM4.32972 10.48C4.32972 6.25121 7.77119 2.80974
        12 2.80974V1.7499C7.18586 1.7499 3.26988 5.66588 3.26988 10.48H4.32972ZM12 2.80974C16.2288
        2.80974 19.6702 6.25121 19.6702 10.48H20.7301C20.7301 5.66588 16.8141 1.7499
        12 1.7499V2.80974ZM19.6702 10.48C19.6702 14.7088 16.2288 18.1502 12 18.1502V19.2101C16.8141
        19.2101 20.7301 15.2941 20.7301 10.48H19.6702ZM2.47008 10.48C2.47008 15.7343 6.74429 20.0099
        12 20.0099V18.9501C7.32972 18.9501 3.52992 15.1491 3.52992 10.48H2.47008ZM12 20.0099C17.2557
        20.0099 21.5299 15.7343 21.5299 10.48H20.4701C20.4701 15.1491 16.6703 18.9501 12
        18.9501V20.0099ZM21.5299 10.48C21.5299 5.22432 17.2557 0.95006 12 0.95006V2.0099C16.6703
        2.0099 20.4701 5.80965 20.4701 10.48H21.5299ZM12 0.95006C6.74434 0.95006 2.47008
        5.22432 2.47008 10.48H3.52992C3.52992 5.80965 7.32967 2.0099 12 2.0099V0.95006Z"
      fill="#333333"
    />
  </svg>,
  'ProxExtraPerks'
);

export const OffersCardHeader = () => {
  return (
    <div className="sui-flex sui-items-center">
      <Responsive minWidth={641}>
        <div className="sui-mr-3">
          <ProxExtraPerksSVG />
        </div>
        <Typography variant="h4" weight="display" height="tight">Pro Xtra Benefits</Typography>
      </Responsive>

      {/** Mobile header */}
      <Responsive maxWidth={640}>
        <div className="sui-mr-2">
          <ProxExtraPerksSVG />
        </div>
        <Typography variant="h5" weight="display" height="tight">Pro Xtra Benefits</Typography>
      </Responsive>
    </div>
  );
};